/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';

// react-router components
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// @mui material components
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import i18n from 'components/Translation/Translate';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { FetchData } from 'services/Request';
import * as Defi from 'services/Define';
import * as Func from 'services/Function';
import { setBadge, setNotify } from 'redux/actions/appAction';
// import { fetchCriteriaValues } from "services/Criteria";
import db from 'services/Firebase';

// Material Dashboard 2 PRO React components
import MDAvatar from 'components/MDAvatar';

// Material Dashboard 2 PRO React examples
import Sidenav from 'examples/Sidenav';
import Configurator from 'examples/Configurator';

// Material Dashboard 2 PRO React themes
import theme from 'assets/theme';

// Material Dashboard 2 PRO React Dark Mode themes
import themeDark from 'assets/theme-dark';

// Material Dashboard 2 PRO React routes
import routes from 'routes';

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from 'context';

// Images
import SignIn from 'layouts/authen/SignIn';
import PosMiniScreen from 'layouts/pos/PosMiniScreen';

async function notifyUser(notificationText = 'Thank you for enable') {
  if (!('Notification' in window)) {
    alert('Browser does not support notifications');
  } else if (Notification.permission === 'granted') {
    const notification = new Notification(notificationText);
  } else if (Notification.permission !== 'denined') {
    await Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        const notification = new Notification(notificationText);
      }
    });
  }
}

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const dispatchs = useDispatch();
  const { miniSidenav, direction, layout, sidenavColor, darkMode } = controller;
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const { t } = useTranslation();
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const init = () => {
    // fetchCriteriaValues(app.token)
    //   .then(() => {
    //     console.log("Criteria values loaded successfully");
    //   })
    //   .catch((error) => {
    //     console.error("Failed to load criteria values:", error);
    //   });

    FetchData('GET', `/notification`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        dispatchs(setBadge(result.count));
      } else {
        Func.exitApp();
      }
    });

    // setTimeout(function () {
    //   init();
    // }, 60000);
  };

  // const handleNotify = async () => {
  //   if (app.devicenotify !== "") {
  //     onValue(ref(db, `notify/${app.devicenotify}`), (snapshot) => {
  //       const data = snapshot.val();
  //       console.log(data.notify);
  //       if (data.notify !== undefined) {
  //         dispatchs(setNotify(data.notify));
  //       }
  //     });
  //   }
  // };

  const renderRoute = () =>
    routes.map((item) => {
      let found = false;
      let temp_sub = [];

      if (item.collapse) {
        item.collapse.map((sub, i) => {
          const permiss = app.menu.find(({ code }) => code === sub.key);
          if (permiss !== undefined) {
            found = true;
            temp_sub = [...temp_sub, sub];
          }

          return null;
        });
      } else {
        found = true;
      }

      return item.key === 'avatar'
        ? {
            type: 'collapse',
            name: app.user.name,
            key: 'avatar',
            icon: <MDAvatar src={app.user.image} alt={app.user.name} size='sm' />,
            collapse: item.collapse,
          }
        : item.type === 'title'
        ? item
        : found
        ? {
            type: item.type,
            name: t(item.name),
            key: item.key,
            route: item.route,
            icon: item.icon,
            collapse: temp_sub,
            noCollapse: item.noCollapse,
            component: item.component,
          }
        : {};
    });

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const checkPath = () => {
    if (pathname === '/signin') return false;
    if (window.location.pathname.indexOf('/posmini') === 0) return false;

    return true;
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute('dir', direction);
    i18n.changeLanguage(app.lang);
    if (checkPath()) init();
  }, [direction]);

  // useEffect(() => {
  //   if (checkPath()) handleNotify();
  // }, []);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const getRoutesId = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutesId(route.collapse);
      }

      if (route.route) {
        return (
          <Route exact path={`${route.route}/:id`} element={route.component} key={route.key} />
        );
      }

      return null;
    });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === 'dashboard' && (
        <Sidenav
          color={sidenavColor}
          brand={app.user.logo}
          brandName={app.user.branch_name}
          routes={renderRoute()}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      {layout === 'vr' && <Configurator />}
      <Routes>
        {getRoutes(renderRoute())}
        {getRoutesId(routes)}
        <Route exact path='/signin' element={<SignIn />} key='signin' />
        <Route exact path='/posmini' element={<PosMiniScreen />} key='posmini' />
        <Route path='*' element={<Navigate to='/signin' />} />
      </Routes>
    </ThemeProvider>
  );
}
